import {
  Directive,
  ElementRef,
  EventEmitter,
  HostListener,
  Optional,
  Output,
} from '@angular/core';
import { toAppTime } from '@macs-frontend/core/utils/time';
import { Store } from '@ngrx/store';
import { either as E, function as FN, io, option as O, reader as R } from 'fp-ts';
import { NgrxFormControlDirective, SetValueAction } from 'ngrx-forms';
import { parseTime } from '../utils/time-parser';

const handleKeydown = FN.pipe(
  R.ask<{
    value: string;
    store: Store<any>;
    changeValue: EventEmitter<string>;
    formControlDirective?: NgrxFormControlDirective<any, any>;
  }>(),
  R.map(({ value, changeValue, formControlDirective, store }) =>
    FN.pipe(
      value,
      parseTime,
      E.fold(
        () => '',
        x => toAppTime(x, undefined, false),
      ),
      x =>
        FN.pipe(
          formControlDirective,
          O.fromNullable,
          O.fold(
            () => io.of(undefined),
            formControlDirective =>
              FN.pipe(() => {
                store.dispatch(new SetValueAction(formControlDirective.state.id, x));
              }),
          ),
          io.chain(() => () => {
            changeValue.emit(x);
          }),
        ),
    ),
  ),
);

@Directive({
  selector: '[mdTimeMask]',
})
export class TimeMaskDirective {
  @Output() dontShowTooltipAgain = new EventEmitter<boolean>();
  @Output() changeValue = new EventEmitter<string>();

  constructor(
    private el: ElementRef,
    private store: Store<any>,
    @Optional()
    private formControlDirective?: NgrxFormControlDirective<any, any>,
  ) {}

  @HostListener('blur')
  @HostListener('keydown.enter')
  handle() {
    handleKeydown({
      value: this.el.nativeElement.value || '',
      store: this.store,
      changeValue: this.changeValue,
      formControlDirective: this.formControlDirective,
    })();
  }
}
